import { cn } from '@newcore/ui/cn';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Skeleton } from '@newcore/ui/skeleton';
import { textVariants } from '@newcore/ui/variants/typography-text-variants';
import { AppViewMode } from '@/enums/app-view-mode.enums';
import type { AppRowLayout } from '@/types/app-view.types';

const ROW_CLASSES: Record<AppRowLayout, string> = {
  [AppViewMode.CARDS]: 'rounded-xl border border-secondary p-3',
  [AppViewMode.LIST]: 'h-14 pl-2',
};

const ICON_CLASSES: Record<AppRowLayout, string> = {
  [AppViewMode.CARDS]: 'size-12 rounded-xl',
  [AppViewMode.LIST]: 'size-10 rounded-lg',
};

interface ApplicationRowSkeletonProps {
  layout: AppRowLayout;
}

export function ApplicationRowSkeleton({
  layout,
}: ApplicationRowSkeletonProps) {
  return (
    <div
      data-testid='application-row-skeleton'
      className={cn('flex items-center gap-3', ROW_CLASSES[layout])}
    >
      <Skeleton className={cn('shrink-0', ICON_CLASSES[layout])} />
      <Skeleton
        className={cn(
          textVariants({ size: TextSizes.MD }),
          'h-[1em] w-32 rounded-full'
        )}
      />
    </div>
  );
}
